import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useIoContext } from '~/contexts';
import { NativeYoutubePlayer } from './NativeYoutubePlayer';
const toNativeProps = (props)=>({
        url: typeof props.url === 'string' ? props.url : '',
        controls: props.controls,
        playing: props.playing,
        light: props.light === true,
        width: props.width,
        height: props.height,
        className: props.className,
        testId: props.testId,
        title: props.title,
        onStart: props.onStart,
        onPlay: props.onPlay,
        onPause: props.onPause
    });
export const YoutubePlayer = (props)=>{
    const { native, YoutubePlayer: RawYoutubePlayer } = useIoContext();
    if (native.isNative) {
        return /*#__PURE__*/ _jsx(NativeYoutubePlayer, _object_spread({}, toNativeProps(props)));
    }
    return /*#__PURE__*/ _jsx(RawYoutubePlayer, _object_spread({}, props));
};
